import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "attachmentUnit/";

// 教学点资料库 - 列表
export const unitDataPage = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "page", {
           data: _params,
           method: "GET",
         });
       };



// WEBPACK FOOTER //
// ./src/fetch/api/unitDownload.js